// extracted by mini-css-extract-plugin
module.exports = {"horizontalScrollIndicator":"style-module--horizontal-scroll-indicator--3NJBd"};